import * as TabsPrimitive from '@radix-ui/react-tabs';
import type { ReactNode } from 'react';

interface TabsProps {
  value: string;
  onValueChange: (value: string) => void;
  children: ReactNode;
  className?: string;
}

export function Tabs({ value, onValueChange, children, className }: TabsProps) {
  return (
    <TabsPrimitive.Root
      value={value}
      onValueChange={onValueChange}
      className={`tabs-root${className ? ` ${className}` : ''}`}
    >
      {children}
    </TabsPrimitive.Root>
  );
}

interface TabsListProps {
  children: ReactNode;
  'aria-label'?: string;
}

export function TabsList({ children, 'aria-label': ariaLabel }: TabsListProps) {
  return (
    <TabsPrimitive.List className="tabs-list" aria-label={ariaLabel}>
      {children}
    </TabsPrimitive.List>
  );
}

interface TabsTriggerProps {
  value: string;
  children: ReactNode;
}

export function TabsTrigger({ value, children }: TabsTriggerProps) {
  return (
    <TabsPrimitive.Trigger value={value} className="tabs-trigger">
      {children}
    </TabsPrimitive.Trigger>
  );
}

interface TabsContentProps {
  value: string;
  children: ReactNode;
}

export function TabsContent({ value, children }: TabsContentProps) {
  return (
    <TabsPrimitive.Content value={value} className="tabs-content">
      {children}
    </TabsPrimitive.Content>
  );
}
